import { render, staticRenderFns } from "./addappMg.vue?vue&type=template&id=c76d4fe6&scoped=true&"
import script from "./addappMg.vue?vue&type=script&lang=js&"
export * from "./addappMg.vue?vue&type=script&lang=js&"
import style0 from "./addappMg.vue?vue&type=style&index=0&id=c76d4fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76d4fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c76d4fe6')) {
      api.createRecord('c76d4fe6', component.options)
    } else {
      api.reload('c76d4fe6', component.options)
    }
    module.hot.accept("./addappMg.vue?vue&type=template&id=c76d4fe6&scoped=true&", function () {
      api.rerender('c76d4fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/groMore/components/addappMg.vue"
export default component.exports